/**
 * 진단 WSS 연결 — 룸 서버 공개 주소로 Colyseus create("netcheck", {token}) — 교실 룸 조인(joinById)과 같은 매치메이크 HTTP + WS 업그레이드 길.
 * SDK 는 진단을 시작할 때만 불러온다. 가짜 모드(VITE_FIELD_FAKE=1 · 개발 서버)는 dev/fake/fakeNetcheck(지연 · 막힘 흉내).
 * 시험은 setNetcheckConnectForTests 로 바꾼다.
 */
import { NETCHECK_ROOM } from "@picnic-field/room-protocol";
import { readConfig } from "../../../lib/config";
import type { NetcheckConnect } from "../types";

export const colyseusNetcheck: NetcheckConnect = async (wsUrl, token) => {
  const { Client } = await import("@colyseus/sdk");
  const room = await new Client(wsUrl).create(NETCHECK_ROOM, { token });
  room.reconnection.enabled = false;
  room.onMessage("*", () => {});
  return {
    sendBytes: (type, b) => room.sendBytes(type, b),
    send: (type, body) => room.send(type, body),
    onBytes: (type, cb) => room.onMessage(type, (m: Uint8Array) => cb(m)),
    onJson: (type, cb) => room.onMessage(type, (m: unknown) => cb(m)),
    leave: async () => {
      await room.leave(true).catch(() => {});
    },
  };
};

let override: NetcheckConnect | null = null;

export const netcheckConnect: NetcheckConnect = async (wsUrl, token) => {
  if (override) return override(wsUrl, token);
  if (import.meta.env.DEV && readConfig().fake)
    return (await import("../../../dev/fake/fakeNetcheck")).fakeNetcheckConnect(wsUrl, token);
  return colyseusNetcheck(wsUrl, token);
};

/** 시험 전용 — null 이면 기본값 */
export function setNetcheckConnectForTests(f: NetcheckConnect | null) {
  override = f;
}
